import { render, staticRenderFns } from "./Acgih.vue?vue&type=template&id=4b9583c4&scoped=true&"
import script from "./Acgih.vue?vue&type=script&lang=js&"
export * from "./Acgih.vue?vue&type=script&lang=js&"
import style0 from "./Acgih.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Acgih.vue?vue&type=style&index=1&id=4b9583c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9583c4",
  null
  
)

export default component.exports